import {
  GET_FOOD_TABLE_WIDGET_RENDER_DATA,
  GET_FOOD_TABLE_WIDGET_RENDER_DATA_SUCCESS,
  GET_FOOD_TABLE_WIDGET_RENDER_DATA_ERROR,
  POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY,
  POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_SUCCESS,
  POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_ERROR,
  POST_FOOD_TABLE_WIDGET_BOOK,
  POST_FOOD_TABLE_WIDGET_BOOK_SUCCESS,
  POST_FOOD_TABLE_WIDGET_BOOK_ERROR,
  GET_FOOD_TABLE_WIDGET_LIST,
  GET_FOOD_TABLE_WIDGET_LIST_SUCCESS,
  GET_FOOD_TABLE_WIDGET_LIST_ERROR,
  GET_FOOD_TABLE_WIDGET_DATA,
  GET_FOOD_TABLE_WIDGET_DATA_SUCCESS,
  GET_FOOD_TABLE_WIDGET_DATA_ERROR,
  POST_FOOD_TABLE_WIDGET_CREATE,
  POST_FOOD_TABLE_WIDGET_CREATE_SUCCESS,
  POST_FOOD_TABLE_WIDGET_CREATE_ERROR,
  PUT_FOOD_TABLE_WIDGET_UPDATE,
  PUT_FOOD_TABLE_WIDGET_UPDATE_SUCCESS,
  PUT_FOOD_TABLE_WIDGET_UPDATE_ERROR,
  DELETE_FOOD_TABLE_WIDGET_DELETE,
  DELETE_FOOD_TABLE_WIDGET_DELETE_SUCCESS,
  DELETE_FOOD_TABLE_WIDGET_DELETE_ERROR,
  GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH,
  GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_SUCCESS,
  GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_ERROR,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_SUCCESS,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_ERROR,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_SUCCESS,
  POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_ERROR,
  GET_FOOD_TABLE_WIDGET_SEARCH,
  GET_FOOD_TABLE_WIDGET_SEARCH_SUCCESS,
  GET_FOOD_TABLE_WIDGET_SEARCH_ERROR,
  GET_PAYMENT_REQUEST_PUBLIC_DATA,
  GET_PAYMENT_REQUEST_PUBLIC_DATA_SUCCESS,
  GET_PAYMENT_REQUEST_PUBLIC_DATA_ERROR,
  GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA,
  GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_SUCCESS,
  GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_ERROR,
  POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL,
  POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_SUCCESS,
  POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_ERROR,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_SUCCESS,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_ERROR,
  GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW,
  GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_SUCCESS,
  GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_ERROR,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_SUCCESS,
  PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_ERROR,
} from "./actionType";

//Actions

//GET_FOOD_TABLE_WIDGET_RENDER_DATA
export const getFoodTableWidgetRenderData = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_RENDER_DATA,
  payload,
});

export const getFoodTableWidgetRenderDataSuccess = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_RENDER_DATA_SUCCESS,
  payload,
});

export const getFoodTableWidgetRenderDataError = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_RENDER_DATA_ERROR,
  payload,
});

//POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY
export const postFoodTableWidgetCheckAvailability = (payload) => ({
  type: POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY,
  payload,
});

export const postFoodTableWidgetCheckAvailabilitySuccess = (payload) => ({
  type: POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_SUCCESS,
  payload,
});

export const postFoodTableWidgetCheckAvailabilityError = (payload) => ({
  type: POST_FOOD_TABLE_WIDGET_CHECK_AVAILABILITY_ERROR,
  payload,
});

//POST_FOOD_TABLE_WIDGET_BOOK
export const postFoodTableWidgetBook = (payload) => ({
  type: POST_FOOD_TABLE_WIDGET_BOOK,
  payload,
});

export const postFoodTableWidgetBookSuccess = (payload) => ({
  type: POST_FOOD_TABLE_WIDGET_BOOK_SUCCESS,
  payload,
});

export const postFoodTableWidgetBookError = (payload) => ({
  type: POST_FOOD_TABLE_WIDGET_BOOK_ERROR,
  payload,
});

//GET_FOOD_TABLE_WIDGET_LIST
export const getFoodTableWidgetList = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_LIST,
  payload,
});

export const getFoodTableWidgetListSuccess = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_LIST_SUCCESS,
  payload,
});

export const getFoodTableWidgetListError = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_LIST_ERROR,
  payload,
});

//GET_FOOD_TABLE_WIDGET_DATA
export const getFoodTableWidgetData = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_DATA,
  payload,
});

export const getFoodTableWidgetDataSuccess = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_DATA_SUCCESS,
  payload,
});

export const getFoodTableWidgetDataError = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_DATA_ERROR,
  payload,
});

//POST_FOOD_TABLE_WIDGET_CREATE
export const postFoodTableWidgetCreate = (payload) => ({
  type: POST_FOOD_TABLE_WIDGET_CREATE,
  payload,
});

export const postFoodTableWidgetCreateSuccess = (payload) => ({
  type: POST_FOOD_TABLE_WIDGET_CREATE_SUCCESS,
  payload,
});

export const postFoodTableWidgetCreateError = (payload) => ({
  type: POST_FOOD_TABLE_WIDGET_CREATE_ERROR,
  payload,
});

//PUT_FOOD_TABLE_WIDGET_UPDATE
export const putFoodTableWidgetUpdate = (payload) => ({
  type: PUT_FOOD_TABLE_WIDGET_UPDATE,
  payload,
});

export const putFoodTableWidgetUpdateSuccess = (payload) => ({
  type: PUT_FOOD_TABLE_WIDGET_UPDATE_SUCCESS,
  payload,
});

export const putFoodTableWidgetUpdateError = (payload) => ({
  type: PUT_FOOD_TABLE_WIDGET_UPDATE_ERROR,
  payload,
});

//DELETE_FOOD_TABLE_WIDGET_DELETE
export const deleteFoodTableWidgetDelete = (payload) => ({
  type: DELETE_FOOD_TABLE_WIDGET_DELETE,
  payload,
});

export const deleteFoodTableWidgetDeleteSuccess = (payload) => ({
  type: DELETE_FOOD_TABLE_WIDGET_DELETE_SUCCESS,
  payload,
});

export const deleteFoodTableWidgetDeleteError = (payload) => ({
  type: DELETE_FOOD_TABLE_WIDGET_DELETE_ERROR,
  payload,
});

//GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH
export const getFoodTableReservationTableAssignmentActivityLogSearch = (
  payload
) => ({
  type: GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH,
  payload,
});

export const getFoodTableReservationTableAssignmentActivityLogSearchSuccess = (
  payload
) => ({
  type: GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_SUCCESS,
  payload,
});

export const getFoodTableReservationTableAssignmentActivityLogSearchError = (
  payload
) => ({
  type: GET_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ACTIVITY_LOG_SEARCH_ERROR,
  payload,
});

//POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK
export const postFoodTableReservationTableAssignmentLock = (payload) => ({
  type: POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK,
  payload,
});

export const postFoodTableReservationTableAssignmentLockSuccess = (
  payload
) => ({
  type: POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_SUCCESS,
  payload,
});

export const postFoodTableReservationTableAssignmentLockError = (payload) => ({
  type: POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_LOCK_ERROR,
  payload,
});

//POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK
export const postFoodTableReservationTableAssignmentUnlock = (payload) => ({
  type: POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK,
  payload,
});

export const postFoodTableReservationTableAssignmentUnlockSuccess = (
  payload
) => ({
  type: POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_SUCCESS,
  payload,
});

export const postFoodTableReservationTableAssignmentUnlockError = (
  payload
) => ({
  type: POST_FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNLOCK_ERROR,
  payload,
});

//GET_FOOD_TABLE_WIDGET_SEARCH
export const getFoodTableWidgetSearch = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_SEARCH,
  payload,
});
export const getFoodTableWidgetSearchSuccess = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_SEARCH_SUCCESS,
  payload,
});
export const getFoodTableWidgetSearchError = (payload) => ({
  type: GET_FOOD_TABLE_WIDGET_SEARCH_ERROR,
  payload,
});

//GET_PAYMENT_REQUEST_PUBLIC_DATA
export const getPaymentRequestPublicData = (payload) => ({
  type: GET_PAYMENT_REQUEST_PUBLIC_DATA,
  payload,
});
export const getPaymentRequestPublicDataSuccess = (payload) => ({
  type: GET_PAYMENT_REQUEST_PUBLIC_DATA_SUCCESS,
  payload,
});
export const getPaymentRequestPublicDataError = (payload) => ({
  type: GET_PAYMENT_REQUEST_PUBLIC_DATA_ERROR,
  payload,
});

//GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA
export const getFoodTableReservationPublicRenderData = (payload) => ({
  type: GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA,
  payload,
});
export const getFoodTableReservationPublicRenderDataSuccess = (payload) => ({
  type: GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_SUCCESS,
  payload,
});
export const getFoodTableReservationPublicRenderDataError = (payload) => ({
  type: GET_FOOD_TABLE_RESERVATION_PUBLIC_RENDER_DATA_ERROR,
  payload,
});

//POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL
export const postFoodTableReservationPublicCancel = (payload) => ({
  type: POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL,
  payload,
});
export const postFoodTableReservationPublicCancelSuccess = (payload) => ({
  type: POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_SUCCESS,
  payload,
});
export const postFoodTableReservationPublicCancelError = (payload) => ({
  type: POST_FOOD_TABLE_RESERVATION_PUBLIC_CANCEL_ERROR,
  payload,
});

// Task 24278 - request-to-book approve
export const putFoodTableReservationRequestApprove = (payload) => ({
  type: PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE,
  payload,
});
export const putFoodTableReservationRequestApproveSuccess = (payload) => ({
  type: PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_SUCCESS,
  payload,
});
export const putFoodTableReservationRequestApproveError = (payload) => ({
  type: PUT_FOOD_TABLE_RESERVATION_REQUEST_APPROVE_ERROR,
  payload,
});

// Task 24278 - request-to-book decline preview
export const getFoodTableReservationRequestDeclinePreview = (payload) => ({
  type: GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW,
  payload,
});
export const getFoodTableReservationRequestDeclinePreviewSuccess = (
  payload
) => ({
  type: GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_SUCCESS,
  payload,
});
export const getFoodTableReservationRequestDeclinePreviewError = (payload) => ({
  type: GET_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_PREVIEW_ERROR,
  payload,
});

// Task 24278 - request-to-book decline
export const putFoodTableReservationRequestDecline = (payload) => ({
  type: PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE,
  payload,
});
export const putFoodTableReservationRequestDeclineSuccess = (payload) => ({
  type: PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_SUCCESS,
  payload,
});
export const putFoodTableReservationRequestDeclineError = (payload) => ({
  type: PUT_FOOD_TABLE_RESERVATION_REQUEST_DECLINE_ERROR,
  payload,
});
